<div
  class="d-flex justify-content-center align-items-center w-100 h-100 loader-container"
>
  <ng-lottie
    [options]="options"
  ></ng-lottie>
</div>
